module.exports = __webpack_public_path__ + "static/media/vienna-9.596691e9.jpg";